import './navbar.scss';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import fb from '../../assets/fb.png'
import { Link } from 'react-router-dom';


const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="leftnav">
          <li><a href="/#others">Rashifal</a></li>
          
          <li><Link to='/jyotish/kundali'>Kundli</Link></li>

          <li><a href="/#todayHoroscope">Today Horoscope</a></li>

           <li><Link to="/calender/hindu">Calendar</Link></li>
           

          <li><a href="/blog">Blog</a></li>
        </div>

        <div className="rightnav">
            <div className="ai">
              <Link to= '/#contact'>
                <button>Chat with Astrologer</button></Link>
                <div className="status">
                </div>
            </div>
            <div className="icons">
                <span>Follow us on</span>
               
                <Link to="https://x.com/AsthaDDestiny?mx=2" target="_blank" rel="noopener noreferrer">
                  <TwitterIcon />
                </Link>
                <Link to="https://www.facebook.com/astronumerovastu/" target="_blank" rel="noopener noreferrer">
                  <FacebookIcon />
                </Link>
                <Link to="https://www.instagram.com/astha_d_destiny/" target="_blank" rel="noopener noreferrer">
                  <InstagramIcon />
                </Link>
                <Link to="https://www.linkedin.com/company/ashtha-d-destiny/" target="_blank" rel="noopener noreferrer">
                  <LinkedInIcon />
                </Link>
            
            </div>
        </div>
      </div>
    </nav>
  );
}
export default Navbar;



